<template>
<div>
   <Breadcrumb> 
            <span><router-link :to="{ path:'/'}">Početna</router-link></span>
            <span class="separetor">/</span>
            <span class="font-weight-bolder"><router-link :to="{ name:'kursna-lista'}">Kursna lista</router-link></span>
     </Breadcrumb>
    <section class="has-sidebar u-padding-tb-40">
            <div class="container">
                <div class="row" data-sticky_parent>
                    <div class="col-lg-12 content-wrapper">
                        <div data-sticky_column>
                            <div class="contact-form">
                                <div class="form-title">
                                    <h4>Kursna lista na dan {{ new Date() | date }}</h4>
                                </div>
                                <div class="form-body">
                                    <div class="m-post-content">
                                      <div class="entry-content">
<div class="row">
    <div class="form-group col-md-auto">
        <label for="amount">Jedinica</label>
        <input id="amount" v-model="converter.amount" class="form-control" type="number" v-on:keyup="convert()"/>
    </div>
    <div class="form-group col-md-auto">
                <label for="from">Iz valute</label>
                <select id="from" v-model="converter.from" class="form-control" v-on:change="convert()">
                    <option v-for="(currency,i) in converter.currencies" :key="'from_'+i" v-bind:value="currency.value">{{ currency.text }}</option>        
                </select>
        </div>
            <div class="form-group col-md-auto">
                <label for="to">U valutu</label>
                <select id="to" v-model="converter.to" class="form-control" v-on:change="convert()">
                     <option v-for="(currency,i) in converter.currencies" :key="'to_'+i" v-bind:value="currency.value">{{ currency.text }}</option>
                </select>
              </div>
             <div class="form-group col-md-auto">
                 <label for="course">Po kursu</label>
                <select id="course" v-model="converter.course"  class="form-control" v-on:change="convert()">
                     <option v-for="(course,i) in converter.courses" :key="'course_'+i" v-bind:value="course.value">{{ course.text }}</option>
                </select>          
         </div>
         <div class="form-group col-md-auto u-margin-t-40">
                <h5 id="currencyConverterResult">-</h5>
         </div>
</div>

                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Država</th>
                                                    <th>Šifra valute</th>
                                                    <th>Oznaka valute</th>
                                                    <th>Jedinica</th>
                                                    <th>Kupovni</th>
                                                    <th>Srednji</th>
                                                    <th>Prodajni</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="exchangeRates.length === 0">
                                                    <td id="no-data" colspan="7" class="text-center"></td>
                                                </tr>

                                                <tr v-for="(exchangeRate, i) in exchangeRates" :key="i">
                                                    <td>{{ exchangeRate.Country }}</td>
                                                    <td>{{ exchangeRate.NumCode }}</td>
                                                    <td>{{ exchangeRate.AlphaCode }}</td>
                                                    <td>{{ exchangeRate.Units }}</td>
                                                    <td>{{ exchangeRate.Buy }}</td>
                                                    <td>{{ exchangeRate.Middle }}</td>
                                                    <td>{{ exchangeRate.Sell }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>     
 </template>

<script>
    import { ExchangeRatesService } from '../common/api.service'
    import Breadcrumb from '../components/Breadcrumb'

    export default {
        name: "ExchangeRates",
        components: { Breadcrumb },
        metaInfo: {
            title: 'Kursna lista',        
        },
        data() {
            return {
                exchangeRates: [],
                converter: { 
                    amount: 1, 
                    from:'BAM', 
                    to: 1,
                    course:'kupovni', 
                    currencies: [
                        {value:"BAM", text:"Bosna i Hercegovina (BAM)"},
                        {value:"1", text:"EMU (EUR)"},
                        {value:"2", text:"Australija (AUD)"},
                        {value:"3", text:"Kanada (CAD)"},
                        {value:"4", text:"Hrvatska (HRK)"},
                        {value:"5", text:"Češka R (CZK)"},
                        {value:"6", text:"Danska (DKK)"},
                        {value:"7", text:"Mađarska (HUF)"},
                        {value:"8", text:"Japan (JPY)"},
                        {value:"9", text:"Litvanija (LTL)"},
                        {value:"10", text:"Norveška (NOK)"},
                        {value:"11", text:"Švedska (SEK)"},
                        {value:"12", text:"Švicarska (CHF)"},
                        {value:"13", text:"Turska (TRY)"},
                        {value:"14", text:"V.Britanija (GBP)"},
                        {value:"15", text:"SAD (USD)"},
                        {value:"16", text:"Rusija (RUB)"},
                        {value:"17", text:"Kina (CNY)"},
                        {value:"18", text:"Srbija (RSD)"}
                    ],
                    courses: [
                        {value:"kupovni", text:"Kupovni"},
                        {value:"srednji", text:"Srednji"},
                        {value:"prodajni", text:"Prodajni"},
                    ]
                }
            }
        },
        mounted() {
            window.scrollTo(0, 0);
        },
         created() {
            this.fetchData();     
            this.convert();
        },
        methods: {
            fetchData: function() {
                ExchangeRatesService.getTodaysExchangeRates()
                        .then(res => { 
                            this.exchangeRates = res.data.CurrencyExchangeItems; 
                            if(this.exchangeRates.length === 0) 
                                document.getElementById("no-data").textContent = "Nema podataka za prikazati.";
                           }).catch(error => { document.getElementById("no-data").textContent = "Trenutno nismo u mogućnosti prikazati podatke. Molimo pokušajte kasnije."; });
            },
            convert: function() {
                if(this.converter.amount && this.converter.from && this.converter.to && this.converter.to)
                {
                    ExchangeRatesService.currencyConverter(this.converter.amount, this.converter.from, this.converter.to, this.converter.course)
                                .then(res => document.getElementById("currencyConverterResult").innerText = res.data);
                }
            }
        }
    }
</script>

<style scoped>
    input.form-control {
        height: calc(1.5em + .75rem + 2px);
    }
</style>


// WEBPACK FOOTER //
// src/components/ExchangeRates.vue